import { cn } from '@/platform/lib/utils';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

const widths = {
    sm: 'w-16',
    md: 'w-24',
    lg: 'w-32',
};

const FilterBarPlaceholder = ({ size = 'md', className, ...props }) => (
    <div
        role='status'
        className={cn(
            'inline-flex h-12 animate-pulse items-center gap-1.5 px-4',
            className
        )}
        {...props}
    >
        <span
            className={cn(
                'h-2.5 rounded-full bg-gray-200',
                widths[size] ?? widths.md
            )}
        />
        <ChevronDownIcon className='size-4 text-gray-200' />
        <span className='sr-only'>Laden...</span>
    </div>
);

export default FilterBarPlaceholder;
